export default __webpack_public_path__ + "static/media/tour-browse.c0035fe4.svg";